import React, { useState, useEffect } from 'react'
import { MdAccountCircle, MdOpenInBrowser } from 'react-icons/md'
import { logout } from 'App/helpers/meteor-apollo-accounts'
import { useApolloClient, useQuery } from '@apollo/client'
import sleep from '@orionx-dev/orionsoft-parts/lib/helpers/sleep'
import PropTypes from 'prop-types'
import { Link, useNavigate } from 'react-router-dom'
import VerificationBadge from 'App/Pages/Accounts/Layout/MyWallet/VerificationBadge'
import TransitionIcon from 'App/components/TransitionIcon/TransitionIcon'
import ExitIcon from './icons/exitIcon.svg'
import HelpIcon from './icons/helpIcon.svg'
import QrIcon from './icons/qrIcon.svg'
import SettingsIcon from './icons/settingsIcon.svg'
import TrendingIcon from './icons/trendingIcon.svg'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import styles from './styles.css'
import gql from 'graphql-tag'

const GET_ME = gql`
  query getMe {
    me {
      _id
      email
      introducingBroker
      profile {
        fullName
      }
      country {
        code
        operateFiat
      }
      roles
      verified
    }
  }
`

const Menu = () => {
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()
  const client = useApolloClient()
  const [hover, setHover] = useState(false)

  const { loading, data } = useQuery(GET_ME, { fetchPolicy: 'cache-first' })

  useEffect(() => {
    const closeMenu = async () => {
      if (!open) return true
      await sleep(100)
      setOpen(false)
    }

    window.addEventListener('mouseup', closeMenu, false)

    return () => {
      window.removeEventListener('mouseup', closeMenu)
    }
  }, [open])

  const handleLogout = async () => {
    await logout(client)
  }

  const handleLogin = () => {
    navigate('/login')
  }

  const renderMenu = () => {
    if (!data?.me) return null
    if (!open) return null
    const { country, verified } = data?.me || {}
    return (
      <CSSTransition classNames="user-menu" timeout={{ enter: 200, exit: 200 }}>
        <div className={`${styles.menu} select-none`} key="menu">
          <Link to="/settings" className={styles.account}>
            <div className={styles.name}>
              {(data?.me?.profile && data?.me?.profile.fullName) || 'Mi cuenta'}
            </div>
            <div className={styles.email}>{data?.me?.email}</div>
          </Link>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
            }}>
            <VerificationBadge country={country} verified={verified} width={100} />
          </div>
          <a
            href="https://support.orionx.com"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.menuLink}>
            <img src={HelpIcon} alt="Help Icon" className={styles.menuIcon} size={20} />
            <span className={styles.menuText}>Ayuda</span>
          </a>
          <Link to="/developers" className={styles.menuLink}>
            <img src={QrIcon} alt="Qr Icon" className={styles.menuIcon} size={20} />
            <span className={styles.menuText}>Desarrolladores</span>
          </Link>
          <Link to="/reports" className={styles.menuLink}>
            <img src={TrendingIcon} alt="Trending Icon" className={styles.menuIcon} size={20} />
            <span className={styles.menuText}>Informes</span>
          </Link>
          <Link to="/settings" className={styles.menuLink}>
            <img src={SettingsIcon} alt="Settings Icon" className={styles.menuIcon} size={20} />
            <span className={styles.menuText}>Ajustes</span>
          </Link>
          <a onClick={handleLogout} className={styles.menuLink}>
            <img src={ExitIcon} alt="Exit Icon" className={styles.menuIcon} size={20} />
            <span className={styles.menuText}>Salir</span>
          </a>
        </div>
      </CSSTransition>
    )
  }

  const toggleHover = () => {
    setHover(true)
  }

  const resetHover = () => {
    setHover(false)
  }

  const toggleMenu = () => {
    setOpen(!open)
  }

  const renderIcon = () => {
    if (loading) return null
    const iconStyle = hover ? { opacity: 0.8 } : {}
    const containerStyle = { cursor: 'pointer' }

    return (
      <div
        className={styles.iconContainer}
        onMouseEnter={toggleHover}
        onMouseLeave={resetHover}
        onClick={data?.me ? toggleMenu : handleLogin}
        style={containerStyle}>
        {data?.me ? (
          <MdAccountCircle className={styles.icon} size={32} color="#151EBD" style={iconStyle} />
        ) : (
          <MdOpenInBrowser className={styles.icon} size={32} color="#151EBD" style={iconStyle} />
        )}
        <span className={styles.iconText} style={iconStyle}>
          Mi Cuenta
        </span>
        <TransitionIcon isOpen={open} style={iconStyle} />
      </div>
    )
  }

  return (
    <div className={styles.container}>
      {renderIcon()}
      <TransitionGroup>{renderMenu()}</TransitionGroup>
    </div>
  )
}

Menu.propTypes = {
  router: PropTypes.object,
  me: PropTypes.object,
  client: PropTypes.object,
  loading: PropTypes.bool,
}

export default Menu
